export const artifactKey = (artifactName, dimensions) => {
  return `${artifactName}${dimensions ? "_" + Object.keys(dimensions).sort().map(key => dimensions[key]).filter(Boolean).join("_") : ""}`;
};